<template>
  <div class="t-app__container">
    <heading :overTitle="$t('organize-dashboard-title')" :title="$t('business-dashboard-title')" :text="$t('organize-dashboard-text')" />
    <div class="h-section h-section--small-top">
      <dashboard-tabs />
      <dashboard-section v-if="!hasGathering || !gatheringPublish" :title="$t('dashboard-walktrough-toolbox-title')">
        <link-list :value="walktroughToolboxLinks" />
        <hr />
      </dashboard-section>
      <dashboard-section :title="gatheringName" :suptitle="$t('dashboard-organize-gathering-title')" class="organize-dashboard__gathering">
        <div v-if="hasGathering">
          <span class="organize-dashboard__gathering-status" v-if="gatheringNotSubmitted">{{ $t('dashboard-admin-gathering-notSubmitted-title') }}</span>
          <span class="organize-dashboard__gathering-status" v-else-if="gatheringNotAuthorized">{{ $t('dashboard-admin-gathering-waiting-title') }}</span>
          <span class="organize-dashboard__gathering-status" v-else-if="gatheringCancelled">{{ $t('dashboard-admin-gathering-cancelled-title') }}</span>
          <span class="organize-dashboard__gathering-status" v-else-if="gatheringPublish">{{ $t('dashboard-admin-gathering-authorized-title') }}</span>
          <div class="h-grid">
            <div class="h-grid__col h-grid__col--sm-6">
              <p>
                <strong>{{ $t('gathering-address-title') }}</strong>
                <br />
                {{ gatheringAddress }}
              </p>
            </div>
            <div class="h-grid__col h-grid__col--sm-3">
              <p>
                <strong>{{ $t('gathering-openHours-title') }}</strong
                ><br />
                {{ gatheringOpenHour }}
              </p>
            </div>
            <div class="h-grid__col h-grid__col--sm-3">
              <p>
                <strong>{{ $t('gathering-available-places-title') }}</strong
                ><br />
                {{ gatheringAvailablePlaces }}
              </p>
            </div>
          </div>
          <p>
            <button v-if="gatheringNotSubmitted" class="a-btn-primary" @click="editGathering">{{ $t('edit-gathering-notSubmitted-btn') }}</button>
            <button v-else class="a-btn-primary" @click="editGathering">{{ $t('edit-gathering-btn') }}</button>
            <a v-if="gatheringPublish" target="_blank" :href="this.$t('App.Settings.Preview.Url') + this.$slugiffy(this.myGathering.Name + '-' + this.myGathering.Id)" class="edit-gathering__link">{{
              $t('gathering-link-url')
            }}</a>
          </p>
        </div>
        <p v-else>
          <button class="a-btn-primary" @click="createGathering">{{ $t('create-gathering-btn') }}</button>
        </p>
      </dashboard-section>
      <hr />
      <div v-if="hasGathering && gatheringPublish">
        <dashboard-section :title="$t('dashboard-organize-gathering-business-title')" class="organize-dashboard__business">
          <span class="organize-dashboard__business-number" v-if="gatheringBusiness.length === 1">{{ $t('organize-entrepreneur-count-text', { count: gatheringBusiness.length }) }}</span>
          <span class="organize-dashboard__business-number" v-if="gatheringBusiness.length > 1">{{ $t('organize-entrepreneurs-count-text', { count: gatheringBusiness.length }) }}</span>
          <button class="report-button a-btn-primary-outline a-btn-primary-outline--small" @click="getGatheringBusinessReport">{{ $t('organize-entrepreneurs-download-button') }}</button><br />
          <gathering-business-list :value="gatheringBusiness" :entrepreneurs="entrepreneurs" :users="users" @removeBusiness="removeBusiness" />
          <p>
            <button class="a-btn-primary" @click="exportBusinessEmail">{{ $t('export-business-email-btn') }}</button>
          </p>
          <p>
            <button class="a-btn-primary-outline" type="button" @click="showBusinessListPanel">{{ $t('edit-gathering-entrepreneurs-add-label') }}</button>
          </p>
        </dashboard-section>
        <hr />
      </div>
      <dashboard-section v-if="gatheringPublish" :title="$t('dashboard-organize-toolbox-title')">
        <link-list :value="organizeToolboxLinks" />
      </dashboard-section>
    </div>

    <div class="o-panel" v-bind:class="{ 'o-panel--open': isBusinessListPanelOpen }">
      <div class="o-panel__head">
        <h2 class="o-panel__title">{{ $t('edit-gathering-entrepreneurs-add-title') }}</h2>
        <button type="button" class="o-panel__close" @click="hideBusinessListPanel">{{ $t('panel-close') }}</button>
      </div>
      <div class="o-panel__content">
        <p>{{ $t('search-business-text') }}</p>
        <s-form @submit="searchBusiness">
          <div class="m-from-group">
            <p class="a-form-control">
              <span class="edit-gathering__search-business">
                <input class="edit-gathering__search-business-input" ref="searchTerm" v-model="searchTerm" />
                <button class="edit-gathering__search-business-btn" type="submit">{{ $t('search-business-btn') }}</button>
              </span>
            </p>
            <p v-for="business in searchResult" :key="business.Id">
              <span class="a-form-checkbox">
                <input v-model="newBusinessIds" type="checkbox" :id="`business:${business.Id}`" :value="business.Id" />
                <label :for="`business:${business.Id}`">
                  {{ business.Name }} <a :href="business.Url" target="_blank">{{ $t('business-see-page-link') }}</a
                  ><br />
                  <span class="m-form-group__note m-form-group__note--small m-form-group__note--gray">({{ getEntrepreneursName(business.EntrepreneurIds) }})</span>
                </label>
              </span>
            </p>
            <span v-if="searchResultReceived && searchResult.length === 0">{{ $t('search-business-noresult') }}</span>
            <p v-if="searchResultReceived && searchResult.length > 0">
              &nbsp;&nbsp;
              <a href="javascript:void();" @click="addBusinessIds">{{ $t('add-business-in-gathering-btn') }}</a>
            </p>
          </div>
        </s-form>
      </div>
    </div>
    <div class="o-panel__overlay" @click="hideBusinessListPanel"></div>
  </div>
</template>

<script>
import router from '@/router'
import { URL_CREATE_GATHERING, URL_EDIT_GATHERING } from '@/consts/urls'

import Heading from '@/components/heading'
import SForm from '@/components/form/form'
import DashboardTabs from '@/components/dashboard/dashboard-tabs'
import DashboardSection from '@/components/dashboard/dashboard-section'
import LinkList from '@/components/dashboard/link-list'
import GatheringBusinessList from '@/components/dashboard/gathering/gathering-business-list'

import LoaderService from '@/services/loader'
import GatheringService from '@/services/gathering'
import BusinessService from '@/services/business'
import EntrepreneurService from '@/services/entrepreneur'
import UserService from '@/services/user'

export default {
  components: {
    Heading,
    SForm,
    DashboardTabs,
    DashboardSection,
    GatheringBusinessList,
    LinkList
  },
  data() {
    return {
      myGathering: {},
      entrepreneurs: [],
      gatheringBusiness: [],
      users: [],
      isBusinessListPanelOpen: false,
      searchTerm: '',
      searchResult: [],
      searchResultEntrepreneurs: [],
      searchResultReceived: false,
      newBusinessIds: []
    }
  },
  computed: {
    gatheringNotSubmitted: function() {
      return this.hasGathering && !this.myGathering.IsSubmitted
    },
    gatheringNotAuthorized: function() {
      return this.hasGathering && this.myGathering.IsSubmitted && !this.myGathering.IsPublish && !this.myGathering.IsCancelled
    },
    gatheringPublish: function() {
      return this.hasGathering && this.myGathering.IsPublish
    },
    gatheringCancelled: function() {
      return this.hasGathering && this.myGathering.IsCancelled
    },
    hasGathering: function() {
      return this.myGathering !== {} && this.myGathering !== null && this.myGathering.hasOwnProperty('Id')
    },
    gatheringName: function() {
      if (this.hasGathering) {
        return this.myGathering.Name
      }
      return ''
    },
    gatheringAvailablePlaces: function() {
      if (this.hasGathering) {
        if (this.myGathering.NbKiosk !== 0 && this.myGathering.NbKiosk !== null && this.businessIds) {
          if (this.myGathering.NbKiosk - this.businessIds.length <= 1) {
            return this.$t('gathering-available-place-desc', { places: this.myGathering.NbKiosk - this.businessIds.length })
          } else {
            return this.$t('gathering-available-places-desc', { places: this.myGathering.NbKiosk - this.businessIds.length })
          }
        }
      }

      return this.$t('gathering-places-to-be-determined-text')
    },
    businessIds: function() {
      if (this.hasGathering) {
        return this.myGathering.BusinessIds
      }
      return []
    },
    gatheringOpenHour: function() {
      if (this.myGathering.OpeningTime !== '' && this.myGathering.OpeningTime !== null && this.myGathering.ClosingTime !== '' && this.myGathering.ClosingTime !== null) {
        let text = this.$t('Business.OpeningClosingTime.Text')

        text = text.replace('{openingTime}', this.myGathering.OpeningTime)
        text = text.replace('{closingTime}', this.myGathering.ClosingTime)

        return text
      } else {
        return this.$t('gathering-to-be-determined-text')
      }
    },
    gatheringAddress: function() {
      if (this.myGathering.Address !== null && this.myGathering.Address !== '') {
        return this.myGathering.Address
      } else {
        return this.$t('gathering-to-be-determined-text')
      }
    },
    organizeToolboxLinks: function() {
      return this.$store.getters.organizeToolboxLinks
    },
    walktroughToolboxLinks: function() {
      return this.$store.getters.walktroughToolboxLinks
    }
  },
  methods: {
    getEntrepreneursName: function(ids) {
      var names = this.searchResultEntrepreneurs
        .filter(x => ids.indexOf(x.Id) != -1)
        .map(x => {
          let name = `${x.Name}`
          if (x.Birthdate !== null) {
            name += ` ${this.$t('entrepreneur_age_text', { age: this.getEntrepreneurAge(x) })}`
          }
          return name
        })
      return names.join(', ')
    },
    getEntrepreneurAge(entrepreneur) {
      let ageDifMs = Date.now() - new Date(entrepreneur.Birthdate).getTime()
      let ageDate = new Date(ageDifMs)
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    },
    showBusinessListPanel: function() {
      this.isBusinessListPanelOpen = true
      this.$refs.searchTerm.focus()
    },
    addBusinessIds: async function() {
      this.saveBusinessIds(this.newBusinessIds.concat(this.businessIds))
    },
    removeBusiness(businessId) {
      this.saveBusinessIds(this.businessIds.filter(id => id != businessId))
    },
    saveBusinessIds: async function(businessIds) {
      LoaderService.showLoader()

      let request = {
        gatheringId: this.myGathering.Id
      }
      request.businessIds = { value: businessIds }
      let response = await GatheringService.updateGathering(request)
      let myGathering = response
      this.isBusinessListPanelOpen = false
      let gatheringBusiness = await BusinessService.getBusinessByIds(myGathering.BusinessIds)

      let entrepreneurIds = []
      let userIds = gatheringBusiness.map(x => x.UserId)
      gatheringBusiness.forEach(x => (entrepreneurIds = entrepreneurIds.concat(x.EntrepreneurIds)))
      entrepreneurIds.filter((value, index, self) => {
        return self.indexOf(value) === index
      })

      let entrepreneurs = await EntrepreneurService.getEntrepreneursByIds(entrepreneurIds)
      let users = await UserService.getUserByIds(userIds)

      this.entrepreneurs = entrepreneurs
      this.users = users
      this.gatheringBusiness = gatheringBusiness
      this.myGathering = myGathering

      LoaderService.hideLoader()
    },
    hideBusinessListPanel: function() {
      this.isBusinessListPanelOpen = false
    },
    searchBusiness: async function() {
      LoaderService.showLoader()
      let response = await BusinessService.searchBusiness(this.searchTerm)

      let entrepreneurIds = []
      response.forEach(x => (entrepreneurIds = entrepreneurIds.concat(x.EntrepreneurIds)))
      let entrepreneurs = await EntrepreneurService.getEntrepreneursByIds(entrepreneurIds)

      this.searchResultEntrepreneurs = entrepreneurs
      this.searchResult = response

      this.searchResultReceived = true
      LoaderService.hideLoader()
    },
    createGathering() {
      router.push({ name: URL_CREATE_GATHERING })
    },
    async exportBusinessEmail() {
      let response = await GatheringService.getTutorsByGatheringId(this.myGathering.Id)
      let blob = new Blob([response])
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = this.$slugiffy(`liste-tuteurs-${this.myGathering.Name}`)
      link.click()
    },
    editGathering() {
      router.push({ name: URL_EDIT_GATHERING, params: { id: this.myGathering.Id } })
    },
    getGatheringBusinessReport: async function() {
      await BusinessService.downloadMyGatheringBusinessesReport(this.$slugiffy(this.myGathering.Name))
    }
  },
  async beforeRouteEnter(to, from, next) {
    LoaderService.showLoader()

    let myGathering = await GatheringService.getMyGathering()
    let gatheringBusiness = []
    if (myGathering !== null) {
      gatheringBusiness = await BusinessService.getBusinessByIds(myGathering.BusinessIds)
    }

    let entrepreneurIds = []
    let userIds = gatheringBusiness.map(x => x.UserId)
    gatheringBusiness.forEach(x => (entrepreneurIds = entrepreneurIds.concat(x.EntrepreneurIds)))
    entrepreneurIds.filter((value, index, self) => {
      return self.indexOf(value) === index
    })

    let entrepreneurs = await EntrepreneurService.getEntrepreneursByIds(entrepreneurIds)
    let users = await UserService.getUserByIds(userIds)

    next(vm => {
      vm.myGathering = myGathering
      vm.gatheringBusiness = gatheringBusiness
      vm.entrepreneurs = entrepreneurs
      vm.users = users
      LoaderService.hideLoader()
    })
  }
}
</script>

<style lang="scss">
.edit-gathering {
  &__link {
    margin-left: 24px;
  }
  &__search-business {
    align-items: center;
    display: flex;
    margin-top: -8px;

    &-input {
      border: 0;
      color: inherit;
      height: 100%;
      outline: none;
      width: calc(100% - 50px);
    }

    &-btn {
      appearance: none;
      background: #7667a7 url(~@/assets/search.svg) no-repeat center center;
      background-size: 30px 30px;
      border: 0;
      border-radius: 0px 8px 8px 0px;
      color: transparent;
      cursor: pointer;
      font: 0/0 a;
      height: 50px;
      padding: 0;
      position: relative;
      right: -16px;
      text-shadow: none;
      white-space: nowrap;
      width: 50px;
    }
  }
}

.organize-dashboard__gathering {
  &-status {
    background-color: #a3a3a3;
    border-radius: 4px;
    color: #ffffff;
    display: inline-block;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 24px;
    padding: 3px 14px;
  }
}

.organize-dashboard__business {
  &-number {
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    font-style: italic;
    margin-bottom: 24px;
  }
}

@media screen and (min-width: 768px) {
  .organize-dashboard__gathering {
    position: relative;

    &-status {
      position: absolute;
      right: 0;
      top: 10px;
    }
  }

  .organize-dashboard__business {
    position: relative;

    &-number {
      position: absolute;
      right: 0;
      top: 20px;
    }
  }
}
</style>
